import { store } from "~/state/store";
import { setLocation } from "~/state/user/state";

if (window.geo) {
	const POSITION_INTERVAL = 1000 * 60 * 5; // 5 minut
	const sendPosition = () => {
		window.geo.getCurrentPositionSilently().then(result => {
			if (result?.location && "latitude" in result.location && "longitude" in result.location && "accuracy" in result.location) {
				store.dispatch(setLocation({
					source: "geolocation",
					longitude: result.location.longitude,
					latitude: result.location.latitude,
					accuracy: result.location.accuracy,
					// FIXME: az zacnou tu timestamp skutecne posilat, tak je treba jednak zkontrolovat, ze se cte ze spravne polozky se spravnym typem a jednak dat pryc to Date.now()
					timestamp: parseInt(result.location.timestamp) || Date.now(),
				}));
				Mapy.getComponent("logger").log("geolocation-periodic");
			}
		}, () => {});
	};

	sendPosition();
	setInterval(sendPosition, POSITION_INTERVAL);
}
